import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },
  elementsGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  resourceRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  resourcesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  resouceField: {
    width: '49%',
  },
  trashIcon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    paddingTop: theme.spacing(2.25),
    width: '2%',
  },
  smallTrashIcon: {
    paddingTop: theme.spacing(1.25),
  },
  widthButton: {
    width: 'fit-content',
    lineHeight: `${theme.spacing(2.5)}px !important`,
    fontSize: '14px !important',
    letterSpacing: 0.1,
  },
  readOnlyRow: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
}))
